<template>
  <Form class="modalFormWrap formStyle" ref="form" :model="newInfo" label-position="left" :rules="rules">
    <Row :gutter="30">
      <Col span="12">
        <FormItem prop="name" label="作品名称（60字以内）">
          <Input type="text" v-model="newInfo.name"></Input>
        </FormItem>
      </Col>
      <Col span="12">
        <FormItem prop="designType" label="作品类型">
          <Select v-model="newInfo.designType" placeholder="">
            <Option v-for="t in designTypeList" :value="t.id.toString()" :key="t.id">{{t.name}}</Option>
          </Select>
        </FormItem>
      </Col>
      <Col span="12">
        <FormItem prop="completionDate" label="完成时间">
          <DatePicker type="date" :clearable="false" :editable="false" format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="newInfo.completionDate" @on-change="newInfo.completionDate=$event"></DatePicker>
        </FormItem>
      </Col>
      <Col span="12">
        <FormItem prop="price" label="项目金额（单位：万元）">
          <Input type="text" v-model="newInfo.price"></Input>
        </FormItem>
      </Col>
      <Col span="12">
        <FormItem prop="copyright" label="版权所有方">
          <Select v-model="newInfo.copyright" placeholder="">
            <Option value="SELF">本人</Option>
            <Option value="COMPANY">所在单位</Option>
            <Option value="PARTYA">甲方</Option>
          </Select>
        </FormItem>
      </Col>
      <Col span="12">
        <FormItem prop="copyrightOwner" label="版权所有方名称">
          <Input type="text" v-model="newInfo.copyrightOwner"></Input>
        </FormItem>
      </Col>
      <Col span="24">
        <!-- <FormItem label="项目地点">
          <Input type="text" v-model="newInfo.locationNames"></Input>
        </FormItem> -->

        <Col span="24" class="ivu-form-item-required">
          <span class="ivu-form-item-label">项目地点</span>
        </Col>
        <Col span="8">
          <FormItem prop="locId" :label-width="0">
            <Select 
              v-model="newInfo.locId" 
              placeholder="所在地" 
              @on-open-change="getLocList"
              @on-change="locSelect"
              :readonly="locReadonly"
              :disabled="locReadonly">
              <Option v-for="item in locList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="8">
          <FormItem prop="stateId" :label-width="0">
            <Select 
              v-model="newInfo.stateId" 
              placeholder="省份/大洲" 
              @on-open-change="getStateList"
              @on-change="stateSelect"
              :readonly="locReadonly"
              :disabled="locReadonly">
              <Option v-for="item in stateList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="8">
          <FormItem prop="cityId" :label-width="0">
            <Select 
              v-model="newInfo.cityId" 
              placeholder="城市/国家" 
              @on-open-change="getCityList"
              @on-change="citySelect"
              :readonly="locReadonly"
              :disabled="locReadonly">
              <Option v-for="item in cityList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>
        </Col>
        <!-- <Col span="8" v-if="newInfo.locId==0">
          <FormItem prop="stateId" :label-width="0">
            <Select 
              v-model="newInfo.stateId" 
              placeholder="大洲" 
              @on-open-change="getStateList"
              @on-change="stateSelect">
              <Option v-for="item in stateList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="8" v-if="newInfo.locId==0">
          <FormItem prop="cityId" :label-width="0">
            <Select 
              v-model="newInfo.cityId" 
              placeholder="国家" 
              @on-open-change="getCityList"
              @on-change="citySelect">>
              <Option v-for="item in cityList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>
        </Col> -->

      </Col>
      <Col span="12">
        <FormItem label="关联作品">
          <Input type="text" v-model="newInfo.relationProject"></Input>
        </FormItem>
      </Col>
      <Col span="12">
        <!-- <FormItem label="设计形式">
          <Input type="text" v-model="newInfo.designForm"></Input>
        </FormItem> -->
        <FormItem prop="teamType" label="设计形式">
          <Select v-model="newInfo.teamType" placeholder="">
            <Option value="SELF">个人</Option>
            <Option value="TEAM">团队</Option>
          </Select>
        </FormItem>
      </Col>
      <Col span="24">
        <FormItem label="主创人员（本人可勾选，填写其他用空格隔开）">
          <Checkbox v-model="newInfo.authorSelf" :disabled="newInfo.participantSelf">本人</Checkbox>
          <Input type="text" v-model="newInfo.author"></Input>
        </FormItem>
      </Col>
      <Col span="24">
        <FormItem label="参与人员（本人可勾选，填写其他用空格隔开）">
          <Checkbox v-model="newInfo.participantSelf" :disabled="newInfo.authorSelf">本人</Checkbox>
          <Input type="text" v-model="newInfo.participant"></Input>
        </FormItem>
      </Col>
      <Col :md="12" :xs="24">
        <FormItem label="专利号（非必填，填写并查验无误，即可解锁此条设计价值）">
          <Input type="text" v-model="newInfo.patentNumber" placeholder="例: 202010011420.0"></Input>
        </FormItem>
      </Col>
      <Col :md="12" :xs="24">
        <FormItem label="著作权证书号（非必填，填写并查验无误，即可解锁此条设计价值）">
          <Input type="text" v-model="newInfo.certificateNumber" placeholder="例: No.00000001"></Input>
        </FormItem>
      </Col>
      <Col :md="12" :xs="24" v-if="type=='dragonStar'||type=='competition'">
        <FormItem label="指导老师">
          <Input type="text" v-model="newInfo.teacher"></Input>
        </FormItem>
      </Col>
      <Col span="24">
        <FormItem prop="description" label="设计说明（1000字以内）">
          <Input type="textarea" :autosize="{minRows: 4}" v-model="newInfo.description"></Input>
        </FormItem>
      </Col>
      <Col span="24">
        <span class="ivu-form-item-label">作品图片（图片仅限JPG格式，分辨率建议300dpi，每张图片大小不超过5MB，最多上传30张）</span>
      </Col>
      <Col span="24">
        <div>
          <!-- <Button class="defaultBtn size12" shape="circle">上传项目图片</Button> -->
          <Upload
            ref="upload"
            multiple
            :action="imgApi"
            :headers="{Authorization: token}"
            name="pictures"
            :data="{applyType: 'SCENE'}"
            :show-upload-list="false"
            :on-success="handleSuccess"
            :before-upload="handleBeforeUpload" 
            :on-format-error="handleFormatError"
            :on-error="handleError"
            :on-exceeded-size="handleSize"
            :max-size="5120"
            accept="image/jpg, image/png, image/jpeg">
            <Tooltip theme="light" max-width="200" placement="bottom-start">
              <Button class="defaultBtn size12" shape="circle">上传作品图片</Button>
              <div slot="content" class="size12">
                <p>仅限JPG格式，大小不超过5MB</p>
              </div>
            </Tooltip>
          </Upload>
        </div>
        <div>
          <div class="imgWrap imgLabel" v-for="(picture,i) in uploadList" :key="picture.id">
            <template v-if="picture.status === 'finished'">
              <img class="img" :src="getImageUrl(picture.path, 'avatar')" alt="">
              <div class="imgMask">
                <Icon type="ios-eye-outline" class="eye" @click="openImg(getImageUrl(picture.path))" />
                <Icon type="ios-close-circle-outline" class="delImg" @click="removeImg(i)" />
              </div>
              <div class="size12" v-if="false">
                <div>
                  <span class="lightColor">标签</span>
                  <span class="editLabel" @click="editLabel(picture.id)">编辑</span>  
                  <!-- <span class="editLabel" @click="editLabel(0, 0)">编辑</span>   -->
                </div>
                <div class="labelInput" v-if="isLabelEdit==picture.id">
                  <Input type="text" @on-enter="updateLabel" v-model="picture.labels"></Input>
                </div>
                <!-- <div class="labelInput" v-if="isLabelEdit=='0_0'"><Input type="text" @on-enter="updateLabel"></Input></div> -->
                <div class="ellipsis labelText">{{picture.labels}}</div>
              </div>
            </template>
            <template v-else>
                <Progress v-if="picture.showProgress" :percent="picture.percentage" hide-info></Progress>
            </template>

            <Modal v-model="showLargePic"
              title="查看图片" 
              :footer-hide="true"
              :styles="{top: '50px'}"
              width=640>
              <img :src="largePicPath" v-if="showLargePic" style="width: 100%">
            </Modal>
          </div>  
        </div>
        
      </Col>
      <Col span="24" v-if="type=='dragonStar'||type=='competition'" style="margin-top:24px">
        <span class="ivu-form-item-label">作品视频（视频仅限MP4格式，时长不超过{{videoMaxTime}}分钟，大小不超过{{videoMaxSize/1024}}MB）</span>
      </Col>
      <Col span="24" v-if="type=='dragonStar'||type=='competition'">
        <div>
          <Upload
            ref="videoBtn"
            :action="videoApi"
            :headers="{Authorization: token}"
            name="videos"
            :data="{applyType: 'VIDEO'}"
            :show-upload-list="false"
            :on-success="handleSuccessVideo"
            :before-upload="handleBeforeUploadVideo" 
            :on-format-error="handleFormatErrorVideo"
            :on-error="handleErrorVideo"
            :on-exceeded-size="handleSizeVideo"
            :on-progress="handleProgressVideo"
            :max-size="videoMaxSize"
            accept="video/mp4">
            <Tooltip theme="light" max-width="200" placement="bottom-start">
              <Button class="defaultBtn size12" shape="circle">上传作品视频</Button>
              <div slot="content" class="size12">
                <p>可上传格式：MP4，时长不超过{{videoMaxTime}}分钟，大小不超过{{videoMaxSize/1024}}MB。</p>
              </div>
            </Tooltip>
          </Upload>
        </div>
        <div class="videoWrap">
          <template v-if="newInfo.videos&&newInfo.videos.length>0">
            <video :src="getVideoUrlQCloud(newInfo.videos[0].path)" controls="controls" width="100%" :alt="newInfo.videos[0].name">
              您的浏览器不支持 video 标签。
            </video>
            <div class="imgMask">
              <!-- <Icon type="ios-eye-outline" class="eye" @click="openVideo(getVideoUrlQCloud(newInfo.videos[0].path))" /> -->
              <Icon type="ios-close-circle-outline" class="delImg" @click="removeVideo()"/>
            </div>
          </template>
          <template v-else>
            <Progress v-if="fileUpload.showProgress" :percent="fileUpload.percentage" hide-info></Progress>
          </template>
          <Modal v-model="showLargeVideo"
            title="查看视频" 
            :footer-hide="true"
            :styles="{top: '50px'}"
            width=640>
            <video :src="largeVideoPath" v-if="showLargeVideo"  controls="controls" width="100%">
              您的浏览器不支持 video 标签。
            </video>
          </Modal>
        </div>
      </Col>

      <Col span="24">
        <span class="ivu-form-item-label">参赛承诺书（图片仅限JPG格式，分辨率建议300dpi，图片大小不超过5MB）</span>
      </Col>
      <Col span="24">
        <span class="ivu-form-item-label bulesx" @click="toExport">点击下载参赛承诺书</span>
      </Col>
      <Col span="24">
        <div>
          <Upload
            ref="uploads"
            :action="imgApi"
            :headers="{Authorization: token}"
            name="pictures"
            :data="{applyType: 'PROMISE'}"
            :show-upload-list="false"
            :on-success="handleSuccesss"
            :before-upload="handleBeforeUploads" 
            :on-format-error="handleFormatError"
            :on-error="handleError"
            :on-exceeded-size="handleSize"
            :max-size="5120"
            :limit="1"
            accept="image/jpg, image/png, image/jpeg">
            <Tooltip theme="light" max-width="200" placement="bottom-start">
              <Button class="defaultBtn size12" shape="circle">上传参赛承诺书</Button>
              <div slot="content" class="size12">
                <p>仅限JPG格式，大小不超过5MB</p>
              </div>
            </Tooltip>
          </Upload>
        </div>
        <div>
          <div class="imgWrap imgLabel" v-for="(picture,i) in uploadLists" :key="picture.id">
            <img class="img" :src="getImageUrl(picture.path, 'avatar')" alt="">
            <div class="imgMask">
                <Icon type="ios-eye-outline" class="eye" @click="openImg(getImageUrl(picture.path))" />
                <Icon type="ios-close-circle-outline" class="delImg" @click="removeImgs(i)" />
              </div>
              <div class="size12" v-if="false">
                <div>
                  <span class="lightColor">标签</span>
                  <span class="editLabel" @click="editLabel(picture.id)">编辑</span>  
                  <!-- <span class="editLabel" @click="editLabel(0, 0)">编辑</span>   -->
                </div>
                <div class="labelInput" v-if="isLabelEdit==picture.id">
                  <Input type="text" @on-enter="updateLabel" v-model="picture.labels"></Input>
                </div>
                <!-- <div class="labelInput" v-if="isLabelEdit=='0_0'"><Input type="text" @on-enter="updateLabel"></Input></div> -->
                <div class="ellipsis labelText">{{picture.labels}}</div>
              </div>
            <Modal v-model="showLargePic"
              title="查看图片" 
              :footer-hide="true"
              :styles="{top: '50px'}"
              width=640>
              <img :src="largePicPath" v-if="showLargePic" style="width: 100%">
            </Modal>
          </div>  
        </div>
        
      </Col>
    </Row>
    <div v-if="type=='dragonStar'" class="starBtn">
      <Button class="defaultBtn" shape="circle" @click="saveCompetitionWork">提交参赛作品</Button>
      <Button type="text" class="rightBtn" @click="prevStep">上一步</Button>
    </div>
    <div v-else class="btnWrap">
      <p class="textLeft pdBtm"><span class="addBtn" @click="addWork">添加其它代表作品</span></p>
      <Button class="defaultBtn formBtn" shape="circle" @click="saveWork">保存并跳转至下一未填项</Button>
      <Button type="text" class="rightBtn" @click="skip">跳过此页</Button>
    </div>
  </Form>
</template>

<script>
import centerService from '@/api/center'
import competitionService from '@/api/competition'
import personalService from '@/api/personal'
import { baseUrl } from '@/config/env'
export default {
  props: ['info', 'type'],
  data(){
    return{
      imgApi: `${baseUrl}pictures`,
      videoApi: `${baseUrl}picture/upload-video`,
      token: this.$store.getters.token,
      newInfo: {},
      rules: {
        locId: [{required: true, message: "请选择所在地", trigger: 'blur,change', type: 'number'}],
        stateId: [{required: true, message: "请选择省份/大洲", trigger: 'blur,change', type: 'number'}],
        cityId: [{required: true, message: "请选择城市/国家", trigger: 'blur,change', type: 'number'}],
        name: [{required: true, message: "请输入作品名称（60字以内）", trigger: 'blur,change', max: 60}],
        designType: [{required: true, message: "请选择作品类型", trigger: 'blur,change'}],
        completionDate: [{required: true, message: "请选择完成时间", trigger: 'blur,change', pattern: /.+/}],
        price: [{required: false, message: "金额必须为数字且最多精确到小数点后两位", trigger: 'blur,change', pattern: /^\d{1,10}(\.\d{1,2})?$/}],
        copyright: [{required: true, message: "请选择版权所有方", trigger: 'blur,change'}],
        copyrightOwner: [{required: false, message: "版权所有方名称60字以内", trigger: 'blur,change', max: 60}],
        description: [{required: true, message: "请输入设计说明（1000字以内）", trigger: 'blur', max: 1000}],
      },
      isLabelEdit: null,
      designTypeList: [],
      // 国家
      locList: [],
      stateList: [],
      inStateList: [],
      outStateList: [],
      cityList: [],
      showLargePic: false,
      largePicPath: '',
      uploadList: [],
      uploadLists:[],
      fileUpload: {showProgress: false, percentage: 0},
      showLargeVideo: false,
      largeVideoPath: '',
      videoMaxSize: 81920,
      videoMaxTime: 5,

      locReadonly: false
    }
  },
  mounted(){
    this.uploadList = this.$refs.upload.fileList
    // console.log(this.uploadList)
    this.newInfo = Object.assign({}, {locId: null, stateId: null, cityId: null,participantSelf: false, authorSelf: false}, this.info)
    if(!this.newInfo.pictures){
      this.newInfo.pictures = []
    }else{
      // let {pictures = [],promise = []}  = this.newInfo,
      let receiveList;
      this.newInfo.promise = [];
      receiveList = Object.assign([], this.info.pictures)
      console.log(receiveList)
      for(let i=0;i<receiveList.length;i++){
        receiveList[i].status='finished'
        if(receiveList[i].type == 'PROMISE') {
          this.newInfo.promise.push(receiveList[i])
          this.uploadLists.push(receiveList[i])
          receiveList.splice(i,1)
          break;
        }
      }
      console.log(receiveList)
      this.newInfo.pictures = Object.assign([], receiveList)
      this.uploadList = Object.assign([], receiveList)
    }
    // if(!this.newInfo.promise){
    //   this.newInfo.promise = []
    // }else{
    //   this.newInfo.promise = Object.assign([], this.info.promise)
    //   for(let i=0;i<this.newInfo.promise.length;i++){
    //     this.newInfo.promise[i].status='finished'
    //     this.uploadLists.push(this.newInfo.promise[i])
    //   }
    // }
    
    if(!this.newInfo.videos){
      this.newInfo.videos = []
    }
    //昌都大赛作品所在地锁定昌都
    if(this.newInfo.competitionId && this.newInfo.competitionId == '704428603570320'){
      this.newInfo.locId = 1
      this.newInfo.stateId = 2730
      this.newInfo.cityId = 2740
      this.locReadonly = true
      this.videoMaxSize = 10240
      this.videoMaxTime = 1
    }
    // else{
    //   this.newInfo.videos = Object.assign([], this.info.videos)
    // }
    // console.log(this.uploadList)
    this.newInfo.authorSelf = this.newInfo.authorSelf ? true : false
    this.newInfo.participantSelf = this.newInfo.participantSelf ? true : false
    this.getDesignTypes()
    this.getLocations()
    this.getLocations('state')
    this.getLocations('city')
  },
  methods:{
    toExport(){
      var url = "https://cdwc.ddfddf.com/img/参赛承诺书.doc";
      window.open(url);
    },
    // 龙腾之星提交参赛作品上一步
    prevStep(){
      this.$emit('PrevStep', {})
    },
    skip(){
      this.$emit('Skip', {key: 'workInfo'})
    },
    // 查看大图
    openImg(path){
      // window.open(path, '_blank')
      this.showLargePic = true
      this.largePicPath = path
    },
    // 删除图片
    removeImg(i){
      this.newInfo.pictures.splice(i, 1)
      this.uploadList.splice(i, 1)
    },
    removeImgs(i){
      this.newInfo.promise.splice(i, 1)
      this.uploadLists.splice(i, 1)
    },
    // 查看视频
    openVideo(path){
      // window.open(path, '_blank')
      this.showLargeVideo = true
      this.largeVideoPath = path
    },
    // 删除视频
    removeVideo(){
      this.newInfo.videos.splice(0, 1)

      this.$forceUpdate()
    },
    // 保存参赛作品
    saveCompetitionWork(){
      // console.log(this.newInfo.pictures)
      this.$refs.form.validate(valid => {
        if (valid) {
          let plist = this.newInfo.pictures//承诺书的数组
          let zlist = this.newInfo.promise//作品图的数组
          if(!plist || plist.length == 0){
            this.$Message.error('请上传作品图片')
            return
          }else if(!zlist || zlist.length == 0){
            this.$Message.error('请上传承诺书')
            return
          }else{
            this.newInfo.pictures = [...plist,...zlist]
            for(let i=0; i<this.newInfo.pictures.length; i++){
              this.newInfo.pictures[i].status=null
            }
          }

          if((typeof this.newInfo.completionDate) != 'string'){
            let dt = this.newInfo.completionDate
            // console.log(dt)
            // dt.setHours(dt.getHours() + 8)
            let sYear = dt.getFullYear() + ''
            let sMonth = (dt.getMonth() + 1) < 10 ? '0' + (dt.getMonth() + 1) : (dt.getMonth() + 1) + ''
            let sDate = dt.getDate() < 10 ? '0' + dt.getDate() : dt.getDate() + ''
            let dNew = sYear + '-' + sMonth + '-' + sDate
            // this.newInfo.completionDate = dt.getFullYear() + '-' + (dt.getMonth() + 1) + '-' + dt.getDate()
            this.newInfo.completionDate = dNew
          }
          console.log(this.newInfo.completionDate)
          if(!this.newInfo.competitionId){
            this.newInfo.competitionId = '633125253281936'
          }
          console.log(this.newInfo)
          competitionService.saveProject(this.newInfo)
          .then(res => {
            if(res.errorNo==0){
              this.$emit('EntrySucc')
              this.$Message.info('提交成功')
            }else{
              this.$Message.error(res.errorMessage)
            }
          }).catch( err => {
            // this.$Message.error(err.message)
            console.log(err.message)
            this.$Message.error('连接服务器失败，请稍后再试')
          })
        }else{
          this.$Message.error('信息未正确填写完整')
        }
      })
    },
    // 保存代表作品
    saveWork(){
      // console.log(this.newInfo)
      this.$refs.form.validate(valid => {
        if (valid) {
          if(!this.newInfo.pictures || this.newInfo.pictures.length == 0){
            this.$Message.error('请上传作品图片')
            return
          }else{
            for(let i=0; i<this.newInfo.pictures.length; i++){
              this.newInfo.pictures[i].status=null
            }
          }

          if((typeof this.newInfo.completionDate) != 'string'){
            let dt = this.newInfo.completionDate
            // console.log(dt)
            // dt.setHours(dt.getHours() + 8)
            let sYear = dt.getFullYear() + ''
            let sMonth = (dt.getMonth() + 1) < 10 ? '0' + (dt.getMonth() + 1) : (dt.getMonth() + 1) + ''
            let sDate = dt.getDate() < 10 ? '0' + dt.getDate() : dt.getDate() + ''
            let dNew = sYear + '-' + sMonth + '-' + sDate
            // this.newInfo.completionDate = dt.getFullYear() + '-' + (dt.getMonth() + 1) + '-' + dt.getDate()
            this.newInfo.completionDate = dNew
          }
          console.log(this.newInfo.completionDate)
          personalService.saveProject(this.newInfo)
          .then(res => {
            if(res.errorNo==0){
              this.$Message.info('保存成功')
              this.$parent.$parent.getWorkList()
              this.skip()
            }else{
              this.$Message.error(res.errorMessage)
            }
          }).catch( err => {
            // this.$Message.error(err.message)
            console.log(err.message)
            this.$Message.error('连接服务器失败，请稍后再试')
          })
        }else{
          this.$Message.error('信息未正确填写完整')
        }
      })
    },
    // 
    addWork(){
      this.newInfo = {}
      this.uploadList = []
    },
    // 获取作品类型
    getDesignTypes(){
      centerService.getDesignTypes({'pid.ne': 0, "size": 30})
        .then(res => {
          if(res.errorNo==0){
            this.designTypeList = res.data
          }else{
            this.$Message.error(res.errorMessage)
          }
        }).catch( () => {
          // this.$Message.error(err.message)
          this.$Message.error('连接服务器失败，请稍后再试')
        })
    },
    // 选中国家
    locSelect(){
      this.stateList = []
      this.newInfo.stateId = ''
      this.stateSelect()
      this.$forceUpdate()
    },
    // 选中省份
    stateSelect(){
      this.cityList = []
      this.newInfo.cityId = ''
      this.$forceUpdate()
    },
    // 选中城市
    citySelect(){
      this.$forceUpdate()
    },
    // 获取国家列表
    getLocList(flag){
      if(flag && this.locList.length==0){
        this.getLocations('loc')
      }
    },
    // 获取省份列表
    getStateList(flag){
      if(flag){
        this.$refs.form.validateField('locId', valid => {
          if(!valid){
            if(this.newInfo.locId==0 && this.outStateList.length==0 
              || this.newInfo.locId==1 && this.inStateList.length==0){
              this.getLocations('state')
            }else{
              this.stateList = this.newInfo.locId==0 ? this.outStateList : this.inStateList
            }
          }
        })
      }
    },
    // 获取城市列表
    getCityList(flag){
      if(flag){
        this.$refs.form.validateField('stateId', valid => {
          if(!valid){
            this.getLocations('city')
          }
        })
      }
    },
    // 获取位置列表
    getLocations(flag){
      let promise
      if(flag=='city'){
        promise = centerService.getLocations({'parentid.eq': this.newInfo.stateId})
      }else if(flag=='state'){
        promise = centerService.getLocations({'parentid.eq': this.newInfo.locId})
      }else{
        promise = centerService.getLocations()
      }
      promise.then(res => {
        if(res.errorNo==0){
          if(flag=='city'){
            this.cityList = res.data
          }else if(flag=='state'){
            this.stateList = res.data
            if(this.newInfo.locId==0){
              this.outStateList = res.data
            }
            if(this.newInfo.locId==1){
              this.inStateList = res.data
            }
          }else{
            this.locList = res.data
          }
        }else{
          this.$Message.error(res.errorMessage)
        }
      }).catch(() => {
        // this.$Message.error(err.message)
        this.$Message.error('连接服务器失败，请稍后再试')
      })
    },
    // 参赛书上传图片成功
    handleSuccesss(res, file) {

      if (res.errorNo) {
        this.$Message.error(res.errorMessage)
      } else {
        let data = res.data
        if(data.length > 0){
          this.newInfo.promise.push(data[0])
          this.uploadLists = this.newInfo.promise
          file.path = data[0].path
        }
        console.log(this.newInfo.promise)
        this.$forceUpdate()
      }
    },
    // 作品图片上传成功
    handleSuccess(res, file) {
      if (res.errorNo) {
        this.$Message.error(res.errorMessage)
      } else {
        let data = res.data
        if(data.length > 0){
          // data[0].status = 'finished'
          this.newInfo.pictures.push(data[0])
          file.path = data[0].path
          this.uploadList.push(file)
        }
        console.log(this.newInfo.pictures)
        this.$forceUpdate()
      }
    },
    handleBeforeUploads(file) {
      // let check = true
      let check = this.uploadLists.length < 1
      if (!check) {
        this.$Message.info('最多上传1张图片')
      }
      if(file.size == 0){
        check = false
      }
      // this.uploading = true
      return check;
    },
    handleBeforeUpload(file) {
      // console.log(file)
      // let check = true
      let check = this.uploadList.length < 30
      if (!check) {
        this.$Message.info('最多上传30张图片')
      }
      if(file.size == 0){
        check = false
      }
      // this.uploading = true
      return check;
    },
    // 文件超出最大值5M
    handleSize(){
      this.$Message.info('文件超过最大值5M，请重新选择！')
      // this.uploading = false
    },
    // 文件格式错误提示
    handleFormatError (file) {
      this.$Message.error(`文件${file.name}格式错误`)
      // this.uploading = false
    },
    // 错误提示
    handleError(error){
      this.$Message.error('服务器错误' + error)
      // this.uploading = false
    },
    // 上传视频成功
    handleSuccessVideo(res) {
      this.fileUpload.showProgress = false
      this.fileUpload.percentage = 0
      if (res.errorNo) {
        this.$Message.error(res.errorMessage)
      } else {
        let data = res.data
        if(data.length > 0){
          this.newInfo.videos.push(data[0])
        }
        this.$forceUpdate()
      }
    },
    handleBeforeUploadVideo(file) {
      let check = true
      if(file.size == 0){
        check = false
      }
      this.fileUpload.showProgress = true
      this.newInfo.videos = []
      return check;
    },
    handleProgressVideo(event){
      this.fileUpload.percentage = event.percent*0.9
    },
    // 文件超出最大值80M
    handleSizeVideo(){
      this.fileUpload.showProgress = false
      this.$Message.info('文件超过最大值80M，请重新选择！')
    },
    // 文件格式错误提示
    handleFormatErrorVideo(file) {
      this.fileUpload.showProgress = false
      this.$Message.error(`文件${file.name}格式错误`)
    },
    // 错误提示
    handleErrorVideo(error){
      this.fileUpload.showProgress = false
      // this.$Message.error('服务器错误' + error)
      console.log(error)
      this.$Message.error('服务器错误，请稍后再试')
    },
    // 图片标签编辑
    editLabel(picId){
      let val = picId
      this.isLabelEdit = val==this.isLabelEdit ? null : val
    },
    // 提交图片标签
    updateLabel(){
      let key = this.isLabelEdit
      console.log(key)
      // 提交成功后执行 
      this.isLabelEdit = null
    }
    // 图片标签编辑
    // editLabel(i, j){
    //   let val = `${i}_${j}`
    //   this.isLabelEdit = val==this.isLabelEdit ? null : val
    // },
    // 提交图片标签
    // updateLabel(){
    //   let key = this.isLabelEdit.split('_'), i = key[0], j = key[1]
    //   console.log(i, j)
    //   // 提交成功后执行 
    //   this.isLabelEdit = null
    // }
  }
}
</script>